function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import URI from 'urijs';
import Backbone from '@polleverywhere/backbone';
import InstanceMixin, { Common } from './mixins/_instance_common';
/**
 * Generates the Firehose channel path for instance data.
 * @param {string} path Additional path to append to the base URL.
 * @return {string} Always suffixed with a `.json` extension
 */

function getInstanceChannelPath(path) {
  if (path === void 0) {
    path = '';
  }

  return URI('/instances').segment(this.activity.type() + 's').segment(this.activity.get('participant_key')).suffix('json').toString();
}
/**
 * Generates the Firehose channel path for activity data.
 * @param {string} path Additional path to append to the base URL.
 * @return {string} Always suffixed with a `.json` extension
 */


function getActivityChannelPath() {
  return URI('/').segment(this.activity.type() + 's').segment(this.activity.get('shared_key')).segment('participant').suffix('json').toString();
}

var ParticipantInstance = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(ParticipantInstance, _Backbone$Model);

  function ParticipantInstance() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = ParticipantInstance.prototype;

  _proto.initialize = function initialize(attrs, options) {
    if (attrs === void 0) {
      attrs = {};
    }

    if (options === void 0) {
      options = {};
    }

    _.extend(this, InstanceMixin(this));
    /**
     * Contains reference to the internal activity model.
     * @type {Backbone.Model}
     */


    this.activity = options.activity; // Parse the activity's attributes so it can be normalized.

    this.parse(this.activity.attributes);
  };

  _proto.parse = function parse(data, options) {
    if (data === void 0) {
      data = {};
    }

    if (options === void 0) {
      options = {};
    }

    Common.parseActivity.call(this, data, options); // Keep this model free of attributes.

    return {};
  };

  _createClass(ParticipantInstance, [{
    key: "idAttribute",
    get: function get() {
      return Common.getIdAttribute.call(this);
    }
  }, {
    key: "urlRoot",
    get: function get() {
      return Common.getUrlRoot.call(this);
    }
    /**
     * Read-only property indicating the instance type, which is used to determine
     * the correct resource paths, keys, etc.
     * @return {string}
     */

  }, {
    key: "type",
    get: function get() {
      return 'participant';
    }
    /**
     * Returns the list of Firehose channels this instance subscribes to:
     * => `/:plural_activity_type/:shared_key/shared.json`
     * => `/instances/:plural_activity_type/:participant_key.json`
     * @return {string[]}
     */

  }, {
    key: "channels",
    get: function get() {
      Common.requireAttrs(this.activity.attributes, ['shared_key', 'participant_key']);
      var instanceChannel = getInstanceChannelPath.call(this);
      var activityChannel = getActivityChannelPath.call(this);
      return [instanceChannel, activityChannel];
    }
  }]);

  return ParticipantInstance;
}(Backbone.Model);

export { ParticipantInstance as default };